import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert } from 'react-bootstrap';

// Ensure REACT_APP_API_BASE_URL is defined in your .env file
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ConsultingForm = () => {
  const [loading, setLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [submitStatusType, setSubmitStatusType] = useState(null);
  const [errors, setErrors] = useState({});

  // State to manage visibility of "Other" input fields
  const [showOtherHowHeard, setShowOtherHowHeard] = useState(false);
  const [showOtherApplyingFor, setShowOtherApplyingFor] = useState(false);
  const [showOtherBestDescribesYou, setShowOtherBestDescribesYou] = useState(false);
  const [showOtherPriority, setShowOtherPriority] = useState(false);
  const [showOtherChallenges, setShowOtherChallenges] = useState(false);
  const [showOtherOutcome, setShowOtherOutcome] = useState(false);


     const boxStyle = {
        width: '100%',
        // maxWidth: '400px',
        padding: '20px',
        border: '1px solid violet',
        backgroundColor: 'rgba(238, 130, 238, 0.1)',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flexGrow: 1,
    };

  // Styles for input/textarea/select fields
  const inputFieldStyle = {
    backgroundColor: 'transparent',
    // color: '#333', // Default text color for readability
    fontSize: '1.6rem', // Base font size
    border: '1px solid violet',
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSubmitStatus(null);
    setSubmitStatusType(null);
    setErrors({});

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    // Handle multiple selection for checkboxes
    data.how_heard_about_us = formData.getAll('how_heard_about_us').join(', ');
    data.applying_for = formData.getAll('applying_for').join(', ');
    data.best_describes_you = formData.getAll('best_describes_you').join(', ');
    data.priority_next_months = formData.getAll('priority_next_months').join(', ');
    data.biggest_challenges = formData.getAll('biggest_challenges').join(', ');
    data.specific_outcome = formData.getAll('specific_outcome').join(', ');

    // Handle 'Other' fields if they exist
    // These will now be handled as separate fields
    // Ensure your backend is set up to receive these additional fields

    try {
      const response = await fetch(`${API_BASE_URL}/consulting-request`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (!response.ok) {
        if (result.errors) {
          setErrors(result.errors);
          setSubmitStatus('Please fix the errors below and try again.');
          setSubmitStatusType('danger');
        } else {
          setSubmitStatus(result.message || 'Submission failed.');
          setSubmitStatusType('danger');
        }
      } else {
        setSubmitStatus(result.message || 'Consulting application submitted successfully!');
        setSubmitStatusType('success');
        setErrors({});
        e.target.reset(); // Clear form on successful submission
        // Reset "Other" field visibility
        setShowOtherHowHeard(false);
        setShowOtherApplyingFor(false);
        setShowOtherBestDescribesYou(false);
        setShowOtherPriority(false);
        setShowOtherChallenges(false);
        setShowOtherOutcome(false);
      }
    } catch (error) {
      console.error('Submission error:', error);
      setSubmitStatus('Network or server error. Please try again.');
      setSubmitStatusType('danger');
    } finally {
      setLoading(false);
    }
  };

  const hasError = (field) => errors && errors[field] && errors[field].length > 0;

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={10} lg={8}>
          <div className="p-4">
            <h2 className="text-center mb-4">PWU Consulting Application Form</h2>
            <p className="text-center mb-5">Apply now to work with Jahid Hasan or a certified PWU Consultant for Life Growth, business growth, income scaling, or strategic transformation.</p>

            <Form className="px-5" style={boxStyle} onSubmit={handleSubmit} noValidate>

              {/* --- Section 1: Basic Information --- */}
              <h3 className="mb-3">Section 1: Basic Information</h3>

              <Form.Group className="mb-3" controlId="full_name">
                <Form.Label>Full Name (পুরো নাম)*</Form.Label>
                <Form.Control
                  type="text"
                  name="full_name"
                  required
                  style={inputFieldStyle}
                  isInvalid={hasError('full_name')}
                />
                <Form.Control.Feedback type="invalid">{hasError('full_name') && errors.full_name[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="email_address">
                <Form.Label>Email Address(ইমেইল এড্রেস)*</Form.Label>
                <Form.Control
                  type="email"
                  name="email_address"
                  required
                  style={inputFieldStyle}
                  isInvalid={hasError('email_address')}
                />
                <Form.Control.Feedback type="invalid">{hasError('email_address') && errors.email_address[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="phone_number">
                <Form.Label>Phone Number(ফোন নাম্বার)*</Form.Label>
                <Form.Control
                  type="tel"
                  name="phone_number"
                  required
                  style={inputFieldStyle}
                  isInvalid={hasError('phone_number')}
                />
                <Form.Control.Feedback type="invalid">{hasError('phone_number') && errors.phone_number[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="whatsapp_number">
                <Form.Label>WhatsApp Number(হোয়াটসআপ নাম্বার)*</Form.Label>
                <Form.Control
                  type="tel"
                  name="whatsapp_number"
                  required
                  style={inputFieldStyle}
                  isInvalid={hasError('whatsapp_number')}
                />
                <Form.Control.Feedback type="invalid">{hasError('whatsapp_number') && errors.whatsapp_number[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="company_name">
                <Form.Label>Company Name (if any)(কোম্পানির নাম)</Form.Label>
                <Form.Control
                  type="text"
                  name="company_name"
                  style={inputFieldStyle}
                  isInvalid={hasError('company_name')}
                />
                <Form.Control.Feedback type="invalid">{hasError('company_name') && errors.company_name[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="website_social_media">
                <Form.Label>Website/Social Media (if any)(ওয়েবসাইট/সোশ্যাল মিডিয়া)</Form.Label>
                <Form.Control
                  type="url"
                  name="website_social_media"
                  style={inputFieldStyle}
                  isInvalid={hasError('website_social_media')}
                />
                <Form.Control.Feedback type="invalid">{hasError('website_social_media') && errors.website_social_media[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="city_country">
                <Form.Label>City & Country (শহর ও দেশ)*</Form.Label>
                <Form.Control
                  type="text"
                  name="city_country"
                  required
                  style={inputFieldStyle}
                  isInvalid={hasError('city_country')}
                />
                <Form.Control.Feedback type="invalid">{hasError('city_country') && errors.city_country[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="age">
                <Form.Label>Age (বয়স)*</Form.Label>
                <Form.Control
                  type="number"
                  name="age"
                  required
                  min="18" // Assuming a minimum age
                  style={inputFieldStyle}
                  isInvalid={hasError('age')}
                />
                <Form.Control.Feedback type="invalid">{hasError('age') && errors.age[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>How did you hear about PWU or Jahid's Consulting? (আপনি PWU বা জাহিদের পরামর্শ সম্পর্কে কীভাবে জানলেন?)*</Form.Label>
                {["Facebook", "YouTube", "Website", "Referral", "Live Session", "Other"].map((option, index) => (
                  <Form.Check
                    key={index}
                    type="checkbox"
                    label={option}
                    id={`heard-${option}`}
                    name="how_heard_about_us"
                    value={option}
                    isInvalid={hasError('how_heard_about_us')}
                    onChange={(e) => {
                      if (option === "Other") {
                        setShowOtherHowHeard(e.target.checked);
                      }
                    }}
                  />
                ))}
                {showOtherHowHeard && (
                  <Form.Control
                    type="text"
                    name="how_heard_about_us_other"
                    placeholder="Please specify"
                    className="mt-2"
                    style={inputFieldStyle}
                  />
                )}
                <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>{hasError('how_heard_about_us') && errors.how_heard_about_us[0]}</Form.Control.Feedback>
              </Form.Group>

              {/* --- Section 2: Current Situation --- */}
              <h3 className="mb-3">Section 2: Current Situation</h3>

              <Form.Group className="mb-4">
                <Form.Label>Are you applying for: (আপনি কি জন্য আবেদন করছেন?)*</Form.Label>
                {["One-on-One Business Consulting ( 1 Year Access)", "Strategy Session ( 60-90 Minutes session)", "Strategy Session ( 4 hours or Half Day Session)", "Strategy Session ( 8 hours or Full Day Session)", "Life, Business or Income Audit Program.", "Team Training/Consulting", "Other"].map((option, index) => (
                  <Form.Check
                    key={index}
                    type="checkbox"
                    label={option}
                    id={`applying-${option}`}
                    name="applying_for"
                    value={option}
                    isInvalid={hasError('applying_for')}
                    onChange={(e) => {
                      if (option === "Other") {
                        setShowOtherApplyingFor(e.target.checked);
                      }
                    }}
                  />
                ))}
                {showOtherApplyingFor && (
                  <Form.Control
                    type="text"
                    name="applying_for_other"
                    placeholder="Please specify"
                    className="mt-2"
                    style={inputFieldStyle}
                  />
                )}
                <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>{hasError('applying_for') && errors.applying_for[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>What best describes you? (আপনাকে কীভাবে বর্ণনা করা যায়?)*</Form.Label>
                {["Startup Entrepreneur", "Small Business Owner", "Freelancer", "SME with Team", "Corporate Executive", "Other"].map((option, index) => (
                  <Form.Check
                    key={index}
                    type="checkbox"
                    label={option}
                    id={`desc-${option}`}
                    name="best_describes_you"
                    value={option}
                    isInvalid={hasError('best_describes_you')}
                    onChange={(e) => {
                      if (option === "Other") {
                        setShowOtherBestDescribesYou(e.target.checked);
                      }
                    }}
                  />
                ))}
                {showOtherBestDescribesYou && (
                  <Form.Control
                    type="text"
                    name="best_describes_you_other"
                    placeholder="Please specify"
                    className="mt-2"
                    style={inputFieldStyle}
                  />
                )}
                <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>{hasError('best_describes_you') && errors.best_describes_you[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="current_business_description">
                <Form.Label>Briefly describe your current business or project: (আপনার বর্তমান ব্যবসা বা প্রকল্পটি সংক্ষেপে বর্ণনা করুন:)*</Form.Label>
                <Form.Text className="d-block mb-2">(What you do, your target market, products/services, team size)</Form.Text>
                <Form.Control
                  as="textarea"
                  name="current_business_description"
                  required
                  rows={4}
                  style={inputFieldStyle}
                  isInvalid={hasError('current_business_description')}
                />
                <Form.Control.Feedback type="invalid">{hasError('current_business_description') && errors.current_business_description[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>What’s your current monthly business revenue? (আপনার বর্তমান মাসিক ব্যবসায়িক রাজস্ব কত?) *</Form.Label>
                {["Below 1 Lakh BDT", "1–5 Lakh BDT", "5–20 Lakh BDT", "20 Lakh - 1 Crore BDT", "Above 1 Crore BDT"].map((option, index) => (
                  <Form.Check
                    key={index}
                    type="radio" // Radio for single selection
                    label={option}
                    id={`revenue-${option}`}
                    name="current_monthly_revenue"
                    value={option}
                    required
                    isInvalid={hasError('current_monthly_revenue')}
                  />
                ))}
                <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>{hasError('current_monthly_revenue') && errors.current_monthly_revenue[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>How long have you been running your business or project? (আপনার ব্যবসা বা প্রকল্পটি কতদিন ধরে চলছে?) *</Form.Label>
                {["Less than 1 year", "1–3 years", "3–7 years", "7+ years"].map((option, index) => (
                  <Form.Check
                    key={index}
                    type="radio" // Radio for single selection
                    label={option}
                    id={`business-duration-${option}`}
                    name="business_duration"
                    value={option}
                    required
                    isInvalid={hasError('business_duration')}
                  />
                ))}
                <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>{hasError('business_duration') && errors.business_duration[0]}</Form.Control.Feedback>
              </Form.Group>

              {/* --- Section 3: Goals & Problems --- */}
              <h3 className="mb-3">Section 3: Goals & Problems</h3>

              <Form.Group className="mb-4">
                <Form.Label>What is your #1 priority for the next 6–12 months in your business? (আপনার ব্যবসার জন্য পরবর্তী 6-12 মাসে আপনার #1 অগ্রাধিকার কী?) *</Form.Label>
                {["Scaling Revenue", "Building Structure & Team", "Sales & Marketing Systems", "Branding & Positioning", "Automation & Systems", "Other"].map((option, index) => (
                  <Form.Check
                    key={index}
                    type="checkbox"
                    label={option}
                    id={`priority-${option}`}
                    name="priority_next_months"
                    value={option}
                    isInvalid={hasError('priority_next_months')}
                    onChange={(e) => {
                      if (option === "Other") {
                        setShowOtherPriority(e.target.checked);
                      }
                    }}
                  />
                ))}
                {showOtherPriority && (
                  <Form.Control
                    type="text"
                    name="priority_next_months_other"
                    placeholder="Please specify"
                    className="mt-2"
                    style={inputFieldStyle}
                  />
                )}
                <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>{hasError('priority_next_months') && errors.priority_next_months[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>What are the biggest challenges you're currently facing? (আপনার বর্তমান সবচেয়ে বড় চ্যালেঞ্জগুলি কী?) *</Form.Label>
                {["Lack of consistent income", "No clear systems or strategy", "Marketing is not working", "Poor team performance", "Time management issues", "Other"].map((option, index) => (
                  <Form.Check
                    key={index}
                    type="checkbox"
                    label={option}
                    id={`challenge-${option}`}
                    name="biggest_challenges"
                    value={option}
                    isInvalid={hasError('biggest_challenges')}
                    onChange={(e) => {
                      if (option === "Other") {
                        setShowOtherChallenges(e.target.checked);
                      }
                    }}
                  />
                ))}
                {showOtherChallenges && (
                  <Form.Control
                    type="text"
                    name="biggest_challenges_other"
                    placeholder="Please specify"
                    className="mt-2"
                    style={inputFieldStyle}
                  />
                )}
                <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>{hasError('biggest_challenges') && errors.biggest_challenges[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="stopped_fixing_challenges">
                <Form.Label>What has stopped you from fixing these challenges till now? (আপনার এই চ্যালেঞ্জগুলি এখন পর্যন্ত সমাধান করতে বাধা দিয়েছে কী?) *</Form.Label>
                <Form.Control
                  as="textarea"
                  name="stopped_fixing_challenges"
                  required
                  rows={3}
                  style={inputFieldStyle}
                  isInvalid={hasError('stopped_fixing_challenges')}
                />
                <Form.Control.Feedback type="invalid">{hasError('stopped_fixing_challenges') && errors.stopped_fixing_challenges[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>What specific outcome are you looking to get from our consulting? (আপনার পরামর্শ থেকে আপনি কী নির্দিষ্ট ফলাফল পেতে চান?) *</Form.Label>
                {["Double Revenue", "Systemize Business", "Build a Sales Team", "Increase Profit", "Other"].map((option, index) => (
                  <Form.Check
                    key={index}
                    type="checkbox"
                    label={option}
                    id={`outcome-${option}`}
                    name="specific_outcome"
                    value={option}
                    isInvalid={hasError('specific_outcome')}
                    onChange={(e) => {
                      if (option === "Other") {
                        setShowOtherOutcome(e.target.checked);
                      }
                    }}
                  />
                ))}
                {showOtherOutcome && (
                  <Form.Control
                    type="text"
                    name="specific_outcome_other"
                    placeholder="Please specify"
                    className="mt-2"
                    style={inputFieldStyle}
                  />
                )}
                <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>{hasError('specific_outcome') && errors.specific_outcome[0]}</Form.Control.Feedback>
              </Form.Group>

              {/* --- Section 4: Readiness & Commitment --- */}
              <h3 className="mb-3">Section 4: Readiness & Commitment</h3>

              <Form.Group className="mb-4">
                <Form.Label>How committed are you to transforming your business? (আপনার ব্যবসা রূপান্তরিত করতে আপনি কতটা প্রতিশ্রুতিবদ্ধ?) *</Form.Label>
                {["I’m just exploring", "I’m interested but not urgent", "I’m fully committed and ready now"].map((option, index) => (
                  <Form.Check
                    key={index}
                    type="radio" // Radio for single selection
                    label={option}
                    id={`commitment-${option}`}
                    name="commitment_level"
                    value={option}
                    required
                    isInvalid={hasError('commitment_level')}
                  />
                ))}
                <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>{hasError('commitment_level') && errors.commitment_level[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>If we can help you solve your business challenges, are you willing to invest in personalized consulting? (যদি আমরা আপনাকে আপনার ব্যবসায়িক চ্যালেঞ্জগুলি সমাধান করতে সহায়তা করতে পারি, তবে আপনি কি ব্যক্তিগতকৃত পরামর্শে বিনিয়োগ করতে ইচ্ছুক?) *</Form.Label>
                {["No", "Yes – with a limited budget", "Yes – I’m looking for high ROI, not low price"].map((option, index) => (
                  <Form.Check
                    key={index}
                    type="radio" // Radio for single selection
                    label={option}
                    id={`willingness-${option}`}
                    name="willing_to_invest"
                    value={option}
                    required
                    isInvalid={hasError('willing_to_invest')}
                  />
                ))}
                <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>{hasError('willing_to_invest') && errors.willing_to_invest[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>What budget range are you prepared to invest in consulting? (আপনি পরামর্শে বিনিয়োগ করতে প্রস্তুত কোন বাজেট পরিসীমা?) *</Form.Label>
                {["Below 50,000 BDT", "50,000–500000 Lakh BDT", "5–15 Lakh BDT", "15 Lakh+ BDT"].map((option, index) => (
                  <Form.Check
                    key={index}
                    type="radio" // Radio for single selection
                    label={option}
                    id={`budget-${option}`}
                    name="investment_budget"
                    value={option}
                    required
                    isInvalid={hasError('investment_budget')}
                  />
                ))}
                <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>{hasError('investment_budget') && errors.investment_budget[0]}</Form.Control.Feedback>
              </Form.Group>

              {/* --- Section 5: Final Notes --- */}
              <h3 className="mb-3">Section 5: Final Notes</h3>

              <Form.Group className="mb-4">
                <Form.Label>Do you want to book a discovery/clarity call first? (আপনি কি প্রথমে একটি আবিষ্কার/স্পষ্টতা কল বুক করতে চান?) *</Form.Label>
                {["Yes", "No, I want direct consulting"].map((option, index) => (
                  <Form.Check
                    key={index}
                    type="radio" // Radio for single selection
                    label={option}
                    id={`book-call-${option}`}
                    name="book_discovery_call"
                    value={option}
                    required
                    isInvalid={hasError('book_discovery_call')}
                  />
                ))}
                <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>{hasError('book_discovery_call') && errors.book_discovery_call[0]}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="specific_request">
                <Form.Label>Any specific request or question for Jahid Hasan or our team? (জাহিদ হাসান বা আমাদের দলের জন্য আপনার কি কোন নির্দিষ্ট অনুরোধ বা প্রশ্ন আছে?)</Form.Label>
                <Form.Control
                  as="textarea"
                  name="specific_request"
                  rows={3}
                  style={inputFieldStyle}
                  isInvalid={hasError('specific_request')}
                />
                <Form.Control.Feedback type="invalid">{hasError('specific_request') && errors.specific_request[0]}</Form.Control.Feedback>
              </Form.Group>

              <div className="text-center mt-5 mb-5">
                <Button className="btn-default" variant="primary" type="submit" disabled={loading}>
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{' '}
                      Submitting...
                    </>
                  ) : (
                    'Submit Application'
                  )}
                </Button>
                {submitStatus && (
              <Alert variant={submitStatusType} className="mt-4">
                {submitStatus}
              </Alert>
            )}
              </div>
              <p className="text-center mt-3">Our team will review your answers. If selected, we’ll schedule a clarity call or send you the next step within 24–48 hours.(আপনার উত্তরগুলি পর্যালোচনা করার পর, যদি নির্বাচিত হয়, তবে আমরা একটি স্পষ্টতা কল নির্ধারণ করব বা 24-48 ঘন্টার মধ্যে আপনাকে পরবর্তী পদক্ষেপ পাঠাবো।)</p>

            </Form>
            
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ConsultingForm;